/**
 * 资产相关路由
 */
export default [
  {
    path: "/inquiry",
    name: "inquiry",
    redirect: "/inquiry_search",
    component: () => import("@/views/inquiry/index.vue"),
    children: [
      {
        path: "/inquiry_search",
        name: "inquirySearch",
        component: () => import("@/views/inquiry/_form.vue")
      },
      {
        path: "/inquiry_list",
        name: "inquiryList",
        component: () => import("@/views/inquiry/_list.vue")
      },
      {
        path: "/inquiry_guide",
        name: "inquiryGuide",
        component: () => import("@/views/inquiry/_guide.vue")
      }
    ]
  }
];
